module.exports = __webpack_public_path__ + "static/media/passport.5ab5be74.svg";